<header id="header" class="custom-header">
  <div id="header-menu" class="header-icon" (click)="layout.sidebarToggle()">
    <img class="__open" src="/assets/icons/burger-menu.svg" />
    <img class="__close" src="/assets/icons/close.svg" />
  </div>

  <div id="logo" class="header-logo">
    <oiq-layout-logo [logoSrc]="brandImg" [logoType]="logoType" routerLink="/" alt="Company Logo">
    </oiq-layout-logo>
  </div>

  <div class="powered-by" id="powered-by">
    <img src="/assets/images/oiq-header-powered-by.svg" />
  </div>

  @if (canSearch() && searchVisible()) {
    <oiq-layout-search id="search" (searched)="searched.next($event)"></oiq-layout-search>
  }

  <oiq-notification-button></oiq-notification-button>
  @if (emailAppEnabled && !isImpersonated) {
    <oiq-email-button></oiq-email-button>
  }

  <oiq-layout-account
    [account]="account"
    [isImpersonated]="isImpersonated"
    (logout)="logout.next()"></oiq-layout-account>

  <!--
  <button *ngIf="!isImpersonated" mat-icon-button class="header-icon" (click)="logout.next()">
    <mat-icon>logout</mat-icon>
  </button> -->
</header>
